import React from 'react';
import { useWindowResizeHook } from '@/hooks/useWindowResizeHook';
import { useUserPageContextValueHook } from '@/contexts/UserPageContextProvider';
import { useQueryParamsHook } from '@/hooks/useQueryParamsHook';
import { getPreviewUrl } from '../../getPreviewUrl';

/**
 * PC 오른쪽 고정 미리보기 (공개 페이지 /preview 를 휴대폰 틀 iframe 으로)
 */
export const FdViewer = React.forwardRef(function FdViewer(props, ref) {
    const queryParamsHook = useQueryParamsHook();
    const lcId = queryParamsHook?.params?.lcId;
    const userPage = useUserPageContextValueHook()?.userPage;
    const windowResizeHook = useWindowResizeHook();

    const frameScale = Math.min(windowResizeHook[1] ? windowResizeHook[1] * 0.001 : 0.7, 0.7);
    const url = getPreviewUrl(userPage?.domainName, lcId);

    return (
        <aside className="fixed bottom-0 right-0 top-14 w-[435px] border-l border-black/[0.06] bg-[#ececf0]" aria-label="미리보기">
            <div className="absolute inset-x-0 top-0 flex items-center justify-between px-5 py-3">
                <span className="text-xs font-bold tracking-wide text-gray-500">미리보기</span>
                {userPage?.domainName &&
                    <a href={`https://shool.uk/${userPage.domainName}`} target="_blank" rel="noreferrer" className="rounded-lg px-2 py-1 text-xs font-semibold text-gray-600 hover:bg-black/5">새 창으로 ↗</a>
                }
            </div>
            <div
                className="absolute left-1/2 top-1/2 box-content h-[724px] w-[352px] origin-top-left -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-[44px] border-[12px] border-gray-900 bg-white shadow-[0_30px_60px_-20px_rgba(0,0,0,0.35)]"
                style={{ scale: `${frameScale}` }}
            >
                <iframe
                    ref={ref}
                    src={url}
                    title='page_preview'
                    className="absolute inset-0 h-full w-full cursor-not-allowed border-0"
                ></iframe>
            </div>
        </aside>
    );
})
